import { Navigate } from "react-router-dom";
import useUserProfile from "../components/hooks/profile/useUserProfile";
import { appRoutes } from "./appRoutes";

export interface PublicRouteProps {
  element: JSX.Element;
  restricted?: boolean; /* if the user is loggedin disable navigating onto this page */
}

const PublicRoute = ({ element, restricted }: PublicRouteProps): JSX.Element => {

  const { profile, isLoading } = useUserProfile()

  if (isLoading) {
    return <></>
  }

  if (profile?.workspaces.length === 0 && restricted) {
    return <Navigate to={appRoutes.workspace.noWorkspace} />
  }

  if (profile?.workspaces.length && restricted) {
    return <Navigate to={appRoutes.experiments.root} />
  }

  return element
}

export default PublicRoute
